
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import { themeV5 } from 'theme/v5'

const Alert = ({ children, className, isSuccess, ...props }) => {

  return (
    <Box
      sx={{
        padding: 2,
        ...themeV5.typography.body1,
        color: isSuccess ? themeV5.palette.success.dark : themeV5.palette.error.dark,
        background: isSuccess ? themeV5.palette.success.light : themeV5.palette.error.light,
        borderRadius: '4px',
      }}
      {...props}>
      {children}
    </Box>
  )
}

Alert.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  severity: PropTypes.string,
  isSuccess: PropTypes.bool,
}

export default Alert
